export function requireViteEnv(name: string): string {
  const value = (import.meta as any).env?.[name] as string | undefined;
  if (!value || value.trim() === '') {
    throw new Error(`Missing required Vite env var: ${name}`);
  }
  return value.trim();
}

/** API base URL - in dev ALWAYS uses same-origin /api (Vite proxy) for reliable connectivity. */
function getApiBaseUrl(): string {
  // Development: force same-origin to avoid cross-origin Network Error (proxy forwards to backend)
  if (import.meta.env.DEV) {
    if (typeof window !== 'undefined') {
      return `${window.location.origin}/api`;
    }
    return '/api';
  }
  const envUrl = (import.meta as any).env?.VITE_API_BASE_URL as string | undefined;
  const trimmed = envUrl?.trim() || '';
  if (!trimmed) {
    throw new Error('VITE_API_BASE_URL is required for production');
  }
  return trimmed;
}

export const API_BASE_URL = getApiBaseUrl();

/** Origin for static assets (uploads). Strips /api from base URL. */
export const API_ORIGIN = API_BASE_URL.replace(/\/api\/?$/, '') || API_BASE_URL;